"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _Typography = _interopRequireDefault(require("@micado-digital/react-ui/components/Typography"));

var _reactForm = _interopRequireDefault(require("@micado-digital/react-form"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _de = _interopRequireDefault(require("../../locals/de.json"));

var _en = _interopRequireDefault(require("../../locals/en.json"));

var _FormContent = _interopRequireDefault(require("./FormContent"));

var _AlternativeLogin = _interopRequireDefault(require("./AlternativeLogin.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlternativeLogin = function AlternativeLogin(_ref) {
  var backIcon = _ref.backIcon,
      lang = _ref.lang,
      url = _ref.url,
      onChange = _ref.onChange,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var css = (0, _AlternativeLogin.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default
    }
  });
  var actionURL = url ? url : "".concat(REACT_APP_PATH, "/api/user/resetlogin");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.alternativeLogin, "mco-login-form-alternative-login")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.backLink, "mco-login-form-alternative-login__back-link"),
    variant: "label-small"
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    onClick: function onClick() {
      if (onChange) onChange("login");
    }
  }, backIcon ? backIcon : /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    className: css.backLinkIcon,
    src: "".concat(REACT_APP_PATH, "/img/icons/arrow-left.svg"),
    size: 10
  }), l("reactLoginForm.alternativeLogin.buttons.backToLogin"))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.headline, "mco-login-form-alternative-login__headline")
  }, l("reactLoginForm.alternativeLogin.headline")), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.text, "mco-login-form-alternative-login__text")
  }, l("reactLoginForm.alternativeLogin.text")), /*#__PURE__*/_react.default.createElement(_reactForm.default, {
    action: actionURL
  }, /*#__PURE__*/_react.default.createElement(_FormContent.default, {
    lang: lang,
    onError: onError,
    onSuccess: onSuccess
  })));
};

var _default = AlternativeLogin;
exports.default = _default;